import { Box, Text } from '@opendoor/bricks-next';

const SellingOptions = () => {
  return (
    <Box gap="$12x" $smallerThanMD={{ gap: '$4x' }}>
      <Text tag="h2" typography="$subheaderSmall" $smallerThanMD={{ fontSize: '$subheaderXsmall' }}>
        Selling Options
      </Text>
      <Box gap="$4x">
        <Box
          backgroundColor="$backgroundSecondary"
          borderRadius="$10x"
          paddingVertical="$16x"
          paddingHorizontal="$12x"
        >
          <Text tag="h2" typography="$subheaderMedium" $smallerThanMD={{ fontSize: '$bodyXlarge' }}>
            Sell to Opendoor
          </Text>
          <Text tag="p" typography="$bodyMedium">
            Get a cash offer and avoid making repairs or showing your house. No agent required.
          </Text>
        </Box>
        <Box
          backgroundColor="$backgroundSecondary"
          borderRadius="$10x"
          paddingVertical="$16x"
          paddingHorizontal="$12x"
        >
          <Text tag="h2" typography="$subheaderMedium" $smallerThanMD={{ fontSize: '$bodyXlarge' }}>
            List with Opendoor
          </Text>
          <Text tag="p" typography="$bodyMedium">
            Host showings to compete for the best offer by working with Opendoor and an agent.
          </Text>
          <Box display="block" marginTop="$8x">
            <Text
              tag="span"
              paddingVertical="$2x"
              paddingHorizontal="$8x"
              borderWidth="$1x"
              borderRadius="$10x"
              typography="$bodyXsmall"
              fontWeight="500"
            >
              Available Soon
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default SellingOptions;
